export default __webpack_public_path__ + "static/media/meeting_lg.4ffee2f9.jpg";